import { RestAjax } from '../ajax';

export const rest = new RestAjax();

export default {};



// WEBPACK FOOTER //
// src/common/utils/globals.js